import React, { useState, useEffect, useRef } from "react";
import { Grid } from "@material-ui/core";
import { TableContainer, Button, Box } from "@material-ui/core";
import {
  getTaxCardV2,
  // getTaxCodeWithDuplicate,
  // getTaxCodeByTaxCardId,
  // getTaxCodeByTaxCardIdForIP,
  // getWHTCodeByTaxType,
  // vendorTaxDetail,

  // getTaxCodeByTaxCardIdByDefault,
} from "../../actions";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import getParameterByName from "../../../../Functions/functions";
// import "./style.css";
import "handsontable/dist/handsontable.full.min.css";
import { HotTable } from "@handsontable/react";
import Handsontable from "handsontable";
import { getTaxCodeWithBlock, vendorTaxDetailV2 } from "./taxActions";
import { registerAllModules } from "handsontable/registry";

registerAllModules();

function TaxTableV2({
  formState,
  setFormState,
  invoice_Amount,
  isPo,
  invoicePayload,
  show,
  edit,
  isProceed,
  setTaxErrorMsg,
  taxErrorMsg,
}) {
  const tableData = {
    invoice_Id: invoicePayload?.Invoice_id || 0,
    category: "",
    purchaseType: "",
    supplierJurisdiction: "",
    supplierType: "",
    status: "",
    fillingStatus: "",
    goodsNature: "",
    taxType: "",
    taxCode: "",
    amount: invoice_Amount,

    //   // <<<<===earlier====>  //
    //   // taxId: 0,
    //   // invoice_Id: parseInt(invoicePayload?.Invoice_id) || 0,
    //   // taxType: "",
    //   // taxCode: "",
    //   // amount: invoice_Amount || "",
    //   // comments: "",
    //   // created_By: "",
    //   // created_On: new Date(),
    //   // updated_By: "",
    //   // updated_On: new Date(),
    //   // taxCardId: 0,

    //   // category: "",
    //   // purchaseType: "",
    //   // supplierJurisdiction: "",
    //   // supplierType: "",
    //   // status: "",
    //   // fillingStatus: "",
    //   // goodsNature: "",
  };

  const status = getParameterByName("status");
  const roleName = getParameterByName("roleName");

  const hotRef = useRef(null);
  const [taxCardLoading, setTaxCardLoading] = useState(false);
  const [taxCardData, setTaxCardData] = useState([]);
  const [taxCodeList, setTaxCodeList] = useState([]);
  const [taxCodeListLoading, setTaxCodeListLoading] = useState(true);
  // const [taxErrorMsg, setTaxErrorMsg] = useState("");

  const columnHeaders = [
    "Category",
    "Purchase Type",
    "Supplier Jurisdiction",
    "Supplier Type",
    "Status",
    "Filling Status",
    "Goods Nature",
    "Tax Type",
    "WHT Code",
    "Base Amount",
  ];

  const columnsNames = [
    "category",
    "purchaseType",
    "supplierJurisdiction",
    "supplierType",
    "status",
    "fillingStatus",
    "goodsNature",
    "taxType",
    "taxCode",
    "amount",
  ];
  const addInput = () => {
    const col = hotRef.current.hotInstance.countRows();
    if (col === 0) {
      setFormState((formState) => ({
        ...formState,
        taxCard_List: [
          ...(formState.taxCard_List || []),
          // formState.taxCard_List[formState.taxCard_List?.length - 1],
          {}
        ],
      }));
    } else {
      const lastRowData = hotRef.current.hotInstance.getDataAtRow(
        hotRef.current.hotInstance.countRows() - 1
      );
      hotRef.current.hotInstance.alter("insert_row_below", col, 1);

      const lastRow = hotRef.current.hotInstance.countRows() - 1;
      // lastRowData.forEach((cellData, columnIndex) => {

      //   hotRef.current.hotInstance.setDataAtRowProp(
      //     lastRow,
      //     columnsNames[columnIndex],
      //     cellData ? cellData : ""
      //   );
      // });
      if (lastRowData[0]) {
        for (
          let columnIndex = 0;
          columnIndex < lastRowData?.length;
          columnIndex++
        ) {
          const cellData = lastRowData[columnIndex];
          hotRef.current.hotInstance.setDataAtRowProp(
            lastRow,
            columnsNames[columnIndex],
            cellData ? cellData : ""
          );
        }
      }
    }
  };

  const deleteInput = (index) => {
    const filteredData = formState?.taxCard_List?.filter((x, i) => i !== index);
    if (filteredData?.length === 0) {
      filteredData[0] = tableData;
    }
    setFormState((formState) => ({
      ...formState,
      taxCard_List: filteredData,
    }));

    setTaxErrorMsg("");
  };

  const [whCodes, setWhCodes] = useState([]);
  const [stCodes, setStCodes] = useState([]);
  useEffect(() => {
    getTaxCardV2(setTaxCardLoading, setTaxCardData);
    getTaxCodeWithBlock(
      setTaxCodeList,
      setTaxCodeListLoading,
      setWhCodes,
      setStCodes
    );
    // getTaxCodeWithDuplicate(setTaxCodeList, setTaxCodeListLoading);
    if (
      // (edit === true && formState?.skipTaxStep && roleName === "IP") ||
      (edit === true && roleName === "Tax Team")
    ) {
      vendorTaxDetailV2(
        setFormState,
        invoicePayload?.Vendor_Code,
        invoice_Amount
      );
    }
  }, []);

  const [columns, setColumns] = useState([]);
  useEffect(() => {
    if (taxCardData?.length > 0) {
      const data = [
        {
          data: "category",
          type: "autocomplete",
          source: function (query, process) {
            var _d = [...new Set(taxCardData?.map((i) => i?.category))];
            return process(_d);
          }, //this.stCodes,this.whCodes,
          //
          strict: true,
          width: 100,
        },
        {
          data: "purchaseType",
          type: "autocomplete",
          source: function (query, process) {
            var _category =
              formState?.taxCard_List?.[this.row].category?.trim();
            var _d = [
              ...new Set(
                taxCardData
                  ?.filter((i) => i?.category == _category)
                  .map((i) => i?.purchaseType)
              ),
            ];
            return process(_d);
          }, //this.stCodes,this.whCodes,
          //
          strict: true,
          width: 100,
        },
        {
          data: "supplierJurisdiction",
          type: "autocomplete",
          source: function (query, process) {
            var _category =
              formState?.taxCard_List?.[this.row].category?.trim();
            var _purchaseType =
              formState?.taxCard_List?.[this.row].purchaseType?.trim();
            var _d = [
              ...new Set(
                taxCardData
                  ?.filter(
                    (i) =>
                      i?.category == _category &&
                      i?.purchaseType == _purchaseType
                  )
                  ?.map((i) => i.supplierJurisdiction)
              ),
            ];
            return process(_d);
          }, //this.stCodes,this.whCodes,
          //
          strict: true,
          width: 100,
        },
        {
          data: "supplierType",
          type: "autocomplete",
          source: function (query, process) {
            var _category =
              formState?.taxCard_List?.[this.row].category?.trim();
            var _purchaseType =
              formState?.taxCard_List?.[this.row].purchaseType?.trim();
            var _supplierJurisdiction =
              formState?.taxCard_List?.[this.row].supplierJurisdiction?.trim();
            var _d = [
              ...new Set(
                taxCardData
                  ?.filter(
                    (i) =>
                      i?.category == _category &&
                      i?.purchaseType == _purchaseType &&
                      i.supplierJurisdiction == _supplierJurisdiction
                  )
                  .map((i) => i.supplierType)
              ),
            ];
            return process(_d);
          }, //this.stCodes,this.whCodes,
          //
          strict: true,
          width: 100,
        },
        {
          data: "status",
          type: "autocomplete",
          source: function (query, process) {
            var _category =
              formState?.taxCard_List?.[this.row].category?.trim();
            var _purchaseType =
              formState?.taxCard_List?.[this.row].purchaseType?.trim();
            var _supplierJurisdiction =
              formState?.taxCard_List?.[this.row].supplierJurisdiction?.trim();
            var _supplierType =
              formState?.taxCard_List?.[this.row].supplierType?.trim();
            var _d = [
              ...new Set(
                taxCardData
                  ?.filter(
                    (i) =>
                      i?.category == _category &&
                      i?.purchaseType == _purchaseType &&
                      i.supplierJurisdiction == _supplierJurisdiction &&
                      i.supplierType == _supplierType
                  )
                  .map((i) => i.status)
              ),
            ];
            return process(_d);
          }, //this.stCodes,this.whCodes,
          //
          strict: true,
          width: 100,
        },
        {
          data: "fillingStatus",
          type: "autocomplete",
          source: function (query, process) {
            var _category =
              formState?.taxCard_List?.[this.row].category?.trim();
            var _purchaseType =
              formState?.taxCard_List?.[this.row].purchaseType?.trim();
            var _supplierJurisdiction =
              formState?.taxCard_List?.[this.row].supplierJurisdiction?.trim();
            var _supplierType =
              formState?.taxCard_List?.[this.row].supplierType?.trim();
            var _status = formState?.taxCard_List?.[this.row].status?.trim();
            var _d = [
              ...new Set(
                taxCardData
                  ?.filter(
                    (i) =>
                      i?.category == _category &&
                      i?.purchaseType == _purchaseType &&
                      i.supplierJurisdiction == _supplierJurisdiction &&
                      i.supplierType == _supplierType &&
                      i.status == _status
                  )
                  .map((i) => i.fillingStatus)
              ),
            ];
            return process(_d);
          }, //this.stCodes,this.whCodes,
          //
          strict: true,
          width: 100,
        },
        {
          data: "goodsNature",
          type: "autocomplete",
          source: function (query, process) {
            var _category =
              formState?.taxCard_List?.[this.row].category?.trim();
            var _purchaseType =
              formState?.taxCard_List?.[this.row].purchaseType?.trim();
            var _supplierJurisdiction =
              formState?.taxCard_List?.[this.row].supplierJurisdiction?.trim();
            var _supplierType =
              formState?.taxCard_List?.[this.row].supplierType?.trim();
            var _status = formState?.taxCard_List?.[this.row].status?.trim();
            var _fillingStatus =
              formState?.taxCard_List?.[this.row].fillingStatus?.trim();
            var _d = [
              ...new Set(
                taxCardData
                  ?.filter(
                    (i) =>
                      i?.category == _category &&
                      i?.purchaseType == _purchaseType &&
                      i.supplierJurisdiction == _supplierJurisdiction &&
                      i.supplierType == _supplierType &&
                      i.status == _status &&
                      i.fillingStatus == _fillingStatus
                  )
                  .map((i) => i.goodsNature)
              ),
            ];
            return process(_d);
          }, //this.stCodes,this.whCodes,
          //
          strict: true,
          width: 200,
        },
        {
          type: "dropdown",
          data: "taxType",
          source: function (query, process) {
            var _category =
              formState?.taxCard_List?.[this.row].category == undefined
                ? ""
                : formState?.taxCard_List?.[this.row].category?.trim();
            var _purchaseType =
              formState?.taxCard_List?.[this.row].purchaseType == undefined
                ? ""
                : formState?.taxCard_List?.[this.row].purchaseType?.trim();
            var _supplierJurisdiction =
              formState?.taxCard_List?.[this.row].supplierJurisdiction ==
              undefined
                ? ""
                : formState?.taxCard_List?.[
                    this.row
                  ].supplierJurisdiction?.trim();
            var _supplierType =
              formState?.taxCard_List?.[this.row].supplierType == undefined
                ? ""
                : formState?.taxCard_List?.[this.row].supplierType?.trim();
            var _status =
              formState?.taxCard_List?.[this.row].status == undefined
                ? ""
                : formState?.taxCard_List?.[this.row].status?.trim();
            var _fillingStatus =
              formState?.taxCard_List?.[this.row].fillingStatus == undefined
                ? ""
                : formState?.taxCard_List?.[this.row].fillingStatus?.trim();
            var _goodsNature =
              formState?.taxCard_List?.[this.row].goodsNature == undefined
                ? ""
                : formState?.taxCard_List?.[this.row].goodsNature?.trim();
            var _d = taxCardData?.filter(
              (i) =>
                (i?.category == _category || _category == "") &&
                (i?.purchaseType == _purchaseType || _purchaseType == "") &&
                (i.supplierJurisdiction == _supplierJurisdiction ||
                  _supplierJurisdiction == "") &&
                (i.supplierType == _supplierType || _supplierType == "") &&
                (i.status == _status || _status == "") &&
                (i.fillingStatus == _fillingStatus || _fillingStatus == "") &&
                (i.goodsNature == _goodsNature || _goodsNature == "")
            );
            if (_d?.length > 0) {
              var _t = taxCodeList?.filter(
                (i) => i.TaxCardIds?.split(",").indexOf(_d[0].id.toString()) > -1
              );
              // var _taxType = formState?.taxType_list?.filter(i => taxCodeList.filter(i => i.TaxCardIds != undefined && i.TaxCardIds != '').filter(i => i.TaxCardIds.split(',').filter(i => _d.map(j => j.Id.toString()).includes(i))).map(i => i.WHTaxType).includes(i.substring(0,2)))
              var _taxType = formState?.taxType_list?.filter((i) =>
                _t.map((j) => j.WHTaxType).includes(i.substring(0, 2))
              );
              setTaxErrorMsg("");
              return process(_taxType);
            } else {
              setTaxErrorMsg(
                "Tax Codes are not available with current selection."
              );
            }
          }, //['GST Code','WHT Code'],
          strict: true,
          width: 200,
        },
        {
          type: "autocomplete",
          source: function (query, process) {
            var _type = formState?.taxCard_List?.[this.row].taxType
              ?.split("-")[0]
              ?.trim();

            //var _item = whCodes.filter(i => {return i.WHTaxType == _type}).map(i => {return i.TaxCode + ' - ' + i.Description});

            var _category =
              formState?.taxCard_List?.[this.row].category == undefined
                ? ""
                : formState?.taxCard_List?.[this.row].category?.trim();
            var _purchaseType =
              formState?.taxCard_List?.[this.row].purchaseType == undefined
                ? ""
                : formState?.taxCard_List?.[this.row].purchaseType?.trim();
            var _supplierJurisdiction =
              formState?.taxCard_List?.[this.row].supplierJurisdiction ==
              undefined
                ? ""
                : formState?.taxCard_List?.[
                    this.row
                  ].supplierJurisdiction?.trim();
            var _supplierType =
              formState?.taxCard_List?.[this.row].supplierType == undefined
                ? ""
                : formState?.taxCard_List?.[this.row].supplierType?.trim();
            var _status =
              formState?.taxCard_List?.[this.row].status == undefined
                ? ""
                : formState?.taxCard_List?.[this.row].status?.trim();
            var _fillingStatus =
              formState?.taxCard_List?.[this.row].fillingStatus == undefined
                ? ""
                : formState?.taxCard_List?.[this.row].fillingStatus?.trim();
            var _goodsNature =
              formState?.taxCard_List?.[this.row].goodsNature == undefined
                ? ""
                : formState?.taxCard_List?.[this.row].goodsNature?.trim();
            var _d = taxCardData?.filter(
              (i) =>
                (i?.category == _category || _category == "") &&
                (i?.purchaseType == _purchaseType || _purchaseType == "") &&
                (i.supplierJurisdiction == _supplierJurisdiction ||
                  _supplierJurisdiction == "") &&
                (i.supplierType == _supplierType || _supplierType == "") &&
                (i.status == _status || _status == "") &&
                (i.fillingStatus == _fillingStatus || _fillingStatus == "") &&
                (i.goodsNature == _goodsNature || _goodsNature == "")
            );
            if (roleName === "IP") {
              var _typee = hotRef.current.hotInstance
                .getDataAtCell(this.row, 7)
                ?.split("-")[0]
                ?.trim();
              var _item = whCodes
                .filter((i) => {
                  return i.WHTaxType == _typee;
                })
                .map((i) => {
                  return i.TaxCode + " - " + i.Description;
                });
              var _d = _item.filter((item) => {
                return item.indexOf(query) > -1;
              });
              return process(_d);
            } else {
              var _wcode = whCodes?.filter((i) => {
                return i.WHTaxType == _type;
              });
              if (_d?.length > 0) {
                var _taxCode = _wcode?.filter(function (element, index) {
                  if (
                    element.TaxCardIds == undefined ||
                    element.TaxCardIds == ""
                  )
                    return false;
                  var _c = element.TaxCardIds?.split(",");
                  var _e = _c?.filter((i) =>
                    _d.map((j) => j.id.toString()).includes(i)
                  );
                  return _e?.length > 0;
                });
                var _item = _taxCode.map((i) => {
                  return i.TaxCode + " - " + i.Description;
                });
                var _dd = _item?.filter((item) => {
                  return item.indexOf(query) > -1;
                });
                return process(_dd);
              }
            }
          }, //this.stCodes,this.whCodes,
          //
          strict: true,
          data: "taxCode",
          width: 200,
        }, // Year is a default text column
        {
          width: 160,
          type: "numeric",
          data: "amount",
          numericFormat: {
            pattern: "0,0.00",
            culture: "en-US", // this is the default culture, set up for USD
          },
        },
      ];

      setColumns(data);
    }
  }, [taxCardData, formState?.taxCard_List]);

  const handleBeforeChange = (changes, source) => {
    if (changes[0][1] == "taxCode" && isPo) {
      var _item = formState?.taxCard_List?.filter(
        (i) => i.TaxCode == changes[0][3]
      );
      if (_item?.length > 0) return false;
    } else if (!isPo) {
      //var _item = formState?.taxCard_List?.filter(i => i.taxType == changes[0][3]);
      //if(_item.length > 0)
      //	return false;
    } else if (
      changes[0][1] == "taxType" &&
      (changes[0][3].indexOf("Z2") > -1 ||
        changes[0][3].indexOf("Z4") > -1 ||
        changes[0][3].indexOf("Y2") > -1 ||
        changes[0][3].indexOf("Y4") > -1)
    ) {
      var _item = formState?.taxCard_List?.filter(
        (i) => i.taxType == changes[0][3]
      );
      if (_item?.length > 0 && isPo) return false;
    }
  };
  const filterTaxCards = (row) => {
    var _category =
      formState?.taxCard_List?.[row].category == undefined
        ? ""
        : formState?.taxCard_List?.[row].category.trim();
    var _purchaseType =
      formState?.taxCard_List?.[row].purchaseType == undefined
        ? ""
        : formState?.taxCard_List?.[row].purchaseType.trim();
    var _supplierJurisdiction =
      formState?.taxCard_List?.[row].supplierJurisdiction == undefined
        ? ""
        : formState?.taxCard_List?.[row].supplierJurisdiction.trim();
    var _supplierType =
      formState?.taxCard_List?.[row].supplierType == undefined
        ? ""
        : formState?.taxCard_List?.[row].supplierType.trim();
    var _status =
      formState?.taxCard_List?.[row].status == undefined
        ? ""
        : formState?.taxCard_List?.[row].status.trim();
    var _fillingStatus =
      formState?.taxCard_List?.[row].fillingStatus == undefined
        ? ""
        : formState?.taxCard_List?.[row].fillingStatus.trim();
    var _goodsNature =
      formState?.taxCard_List?.[row].goodsNature == undefined
        ? ""
        : formState?.taxCard_List?.[row].goodsNature.trim();
    var _d = taxCardData.filter(
      (i) =>
        (i.category == _category || _category == "") &&
        (i.purchaseType == _purchaseType || _purchaseType == "") &&
        (i.supplierJurisdiction == _supplierJurisdiction ||
          _supplierJurisdiction == "") &&
        (i.supplierType == _supplierType || _supplierType == "") &&
        (i.status == _status || _status == "") &&
        (i.fillingStatus == _fillingStatus || _fillingStatus == "") &&
        (i.goodsNature == _goodsNature || _goodsNature == "")
    );
    return _d;
  };

  const taxCardListSetter = (index, name, value) => {
    const str = JSON.stringify(formState?.taxCard_List);
    const tempArr = JSON.parse(str);
    tempArr[index][name] = value;

    setFormState((formState) => ({
      ...formState,
      taxCard_List: tempArr,
    }));
  };

  const handleAfterChange = (changes, source) => {
    if (changes == null || changes == undefined) return;
    if (changes[0][1] == "taxType") {
      if (!isPo) {
        // formState?.taxCard_List?.[changes[0][0]].amount = invoice_Amount;
        taxCardListSetter(changes[0][0], "amount", invoice_Amount);
      } else if (
        formState?.taxCard_List?.filter(
          (i) => i.taxType == formState?.taxCard_List?.[changes[0][0]].taxType
        )?.length <= 1
      )
        // formState?.taxCard_List?.[changes[0][0]].amount = invoice_Amount;
        taxCardListSetter(changes[0][0], "amount", invoice_Amount);
      var _type = formState?.taxCard_List?.[changes[0][0]].taxType
        ?.split("-")[0]
        ?.trim();
      var _d = filterTaxCards(changes[0][0]);
      if (_d?.length > 0) {
        var _wcode = whCodes.filter((i) => {
          return i.WHTaxType == _type;
        });
        var _taxCode = _wcode.filter(function (element, index) {
          if (element.TaxCardIds == undefined || element.TaxCardIds == "")
            return false;
          var _c = element.TaxCardIds?.split(",");
          var _e = _c.filter((i) => _d.map((j) => j.id.toString()).includes(i));
          return _e?.length > 0;
        });
        var _item = _taxCode.map((i) => {
          return i.TaxCode + " - " + i.Description;
        });
        taxCardListSetter(changes[0][0], "taxCode", _item[0]);
        // formState?.taxCard_List?.[changes[0][0]].taxCode = _item[0];
      }

      // app.$refs.myTable.table.render();
    } else if (changes[0][1] == "taxCode") {
      if (!isPo) {
        // formState?.taxCard_List?.[changes[0][0]].amount = invoice_Amount;
        taxCardListSetter(changes[0][0], "amount", invoice_Amount);
      } else if (
        formState?.taxCard_List?.filter(
          (i) => i.taxType == formState?.taxCard_List?.[changes[0][0]].taxType
        )?.length <= 1
      )
        // formState?.taxCard_List?.[changes[0][0]].amount = invoice_Amount;
        taxCardListSetter(changes[0][0], "amount", invoice_Amount);
      var _d = whCodes.filter(
        (i) =>
          i.TaxCode ==
            formState?.taxCard_List?.[changes[0][0]]?.taxCode?.substring(
              0,
              2
            ) &&
          i.WHTaxType ==
            formState?.taxCard_List?.[changes[0][0]]?.taxType?.substring(0, 2)
      );
      var _t = filterTaxCards(changes[0][0]).filter(
        (i) => i.id.toString() == _d[0]?.TaxCardIds?.split(",")?.[0]
      );
      if (
        formState?.taxCard_List?.[changes[0][0]].category == "" ||
        formState?.taxCard_List?.[changes[0][0]].category == undefined
      )
        // formState?.taxCard_List?.[changes[0][0]].category = _t[0].category;
        taxCardListSetter(changes[0][0], "category", _t[0]?.category);
      if (
        formState?.taxCard_List?.[changes[0][0]].purchaseType == "" ||
        formState?.taxCard_List?.[changes[0][0]].purchaseType == undefined
      )
        taxCardListSetter(changes[0][0], "purchaseType", _t[0]?.purchaseType);
      // formState?.taxCard_List?.[changes[0][0]].purchaseType = _t[0].purchaseType;
      if (
        formState?.taxCard_List?.[changes[0][0]].supplierJurisdiction == "" ||
        formState?.taxCard_List?.[changes[0][0]].supplierJurisdiction ==
          undefined
      )
        taxCardListSetter(
          changes[0][0],
          "supplierJurisdiction",
          _t[0]?.supplierJurisdiction
        );
      // formState?.taxCard_List?.[changes[0][0]].supplierJurisdiction = _t[0].supplierJurisdiction;
      if (
        formState?.taxCard_List?.[changes[0][0]].supplierType == "" ||
        formState?.taxCard_List?.[changes[0][0]].supplierType == undefined
      )
        taxCardListSetter(changes[0][0], "supplierType", _t[0]?.supplierType);
      // formState?.taxCard_List?.[changes[0][0]].supplierType = _t[0]?.supplierType;
      if (
        formState?.taxCard_List?.[changes[0][0]].status == "" ||
        formState?.taxCard_List?.[changes[0][0]].status == undefined
      )
        taxCardListSetter(changes[0][0], "status", _t[0]?.status);
      // formState?.taxCard_List?.[changes[0][0]].status = _t[0]?.status;
      if (
        formState?.taxCard_List?.[changes[0][0]].fillingStatus == "" ||
        formState?.taxCard_List?.[changes[0][0]].fillingStatus == undefined
      )
        taxCardListSetter(changes[0][0], "fillingStatus", _t[0]?.fillingStatus);
      // formState?.taxCard_List?.[changes[0][0]].fillingStatus = _t[0]?.fillingStatus;
      if (
        formState?.taxCard_List?.[changes[0][0]].goodsNature == "" ||
        formState?.taxCard_List?.[changes[0][0]].goodsNature == undefined
      )
        taxCardListSetter(changes[0][0], "goodsNature", _t[0]?.goodsNature);
      // formState?.taxCard_List?.[changes[0][0]].goodsNature = _t[0]?.goodsNature;
      // app.$refs.myTable.table.render();
    } else if (changes[0][1] == "category") {
      if (!isPo) {
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      } else if (
        formState?.taxCard_List?.filter(
          (i) => i.taxType == formState?.taxCard_List?.[changes[0][0]].taxType
        )?.length <= 1
      )
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      // taxCardListSetter(changes[0][0], "purchaseType", "");
      formState.taxCard_List[changes[0][0]].purchaseType = "";
      // taxCardListSetter(changes[0][0], "supplierJurisdiction", "");
      formState.taxCard_List[changes[0][0]].supplierJurisdiction = "";
      // taxCardListSetter(changes[0][0], "supplierType", "");
      formState.taxCard_List[changes[0][0]].supplierType = "";
      // taxCardListSetter(changes[0][0], "status", "");
      formState.taxCard_List[changes[0][0]].status = "";
      // taxCardListSetter(changes[0][0], "fillingStatus", "");
      formState.taxCard_List[changes[0][0]].fillingStatus = "";
      // taxCardListSetter(changes[0][0], "goodsNature", "");
      formState.taxCard_List[changes[0][0]].goodsNature = "";
      var _d = filterTaxCards(changes[0][0]);
      // taxCardListSetter(changes[0][0], "purchaseType", _d[0].purchaseType);
      formState.taxCard_List[changes[0][0]].purchaseType = _d[0].purchaseType;
      // taxCardListSetter(changes[0][0], "supplierJurisdiction", _d[0].supplierJurisdiction );
      formState.taxCard_List[changes[0][0]].supplierJurisdiction =
        _d[0].supplierJurisdiction;
      // taxCardListSetter(changes[0][0], "supplierType", _d[0].supplierType);
      formState.taxCard_List[changes[0][0]].supplierType = _d[0].supplierType;
      // taxCardListSetter(changes[0][0], "status", _d[0].status);
      formState.taxCard_List[changes[0][0]].status = _d[0].status;
      // taxCardListSetter(changes[0][0], "fillingStatus", _d[0].fillingStatus);
      formState.taxCard_List[changes[0][0]].fillingStatus = _d[0].fillingStatus;
      // taxCardListSetter(changes[0][0], "goodsNature", _d[0].goodsNature);
      formState.taxCard_List[changes[0][0]].goodsNature = _d[0].goodsNature;
      var _t = taxCodeList.filter(
        (i) => i.TaxCardIds?.split(",").indexOf(_d[0].id.toString()) > -1
      );
      var _taxType = formState?.taxType_list?.filter((i) =>
        _t.map((j) => j.WHTaxType).includes(i.substring(0, 2))
      );
      if (_taxType?.length > 0) {
        taxCardListSetter(changes[0][0], "taxType", _taxType[0]);
        formState.taxCard_List[changes[0][0]].taxType = _taxType[0];
        setTaxErrorMsg("");
      } else {
        setTaxErrorMsg("Tax Codes are not available with current selection.");
      }
      // app.$refs.myTable.table.render();
    } else if (changes[0][1] == "purchaseType") {
      if (!isPo) {
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      } else if (
        formState?.taxCard_List?.filter(
          (i) => i.taxType == formState?.taxCard_List?.[changes[0][0]].taxType
        )?.length <= 1
      )
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      // taxCardListSetter(changes[0][0], "supplierJurisdiction", "");
      formState.taxCard_List[changes[0][0]].supplierJurisdiction = "";
      // taxCardListSetter(changes[0][0], "supplierType", "");
      formState.taxCard_List[changes[0][0]].supplierType = "";
      // taxCardListSetter(changes[0][0], "status", "");
      formState.taxCard_List[changes[0][0]].status = "";
      // taxCardListSetter(changes[0][0], "fillingStatus", "");
      formState.taxCard_List[changes[0][0]].fillingStatus = "";
      // taxCardListSetter(changes[0][0], "goodsNature", "");
      formState.taxCard_List[changes[0][0]].goodsNature = "";
      var _d = filterTaxCards(changes[0][0]);
      // taxCardListSetter( changes[0][0], "supplierJurisdiction", _d[0].supplierJurisdiction );
      formState.taxCard_List[changes[0][0]].supplierJurisdiction =
        _d[0].supplierJurisdiction;
      // taxCardListSetter(changes[0][0], "supplierType", _d[0].supplierType);
      formState.taxCard_List[changes[0][0]].supplierType = _d[0].supplierType;
      // taxCardListSetter(changes[0][0], "status", _d[0].status);
      formState.taxCard_List[changes[0][0]].status = _d[0].status;
      // taxCardListSetter(changes[0][0], "fillingStatus", _d[0].fillingStatus);
      formState.taxCard_List[changes[0][0]].fillingStatus = _d[0].fillingStatus;
      // taxCardListSetter(changes[0][0], "goodsNature", _d[0].goodsNature);
      formState.taxCard_List[changes[0][0]].goodsNature = _d[0].goodsNature;
      // var _taxType = formState?.taxType_list.filter(i => taxCodeList.filter(i => i.TaxCardIds != undefined && i.TaxCardIds != '').filter(i => i.TaxCardIds.split(',').filter(i => _d.map(j => j.id.toString()).includes(i))).map(i => i.WHTaxType).includes(i.substring(0,2)));
      var _t = taxCodeList.filter(
        (i) => i.TaxCardIds?.split(",").indexOf(_d[0].id.toString()) > -1
      );
      var _taxType = formState?.taxType_list?.filter((i) =>
        _t.map((j) => j.WHTaxType).includes(i.substring(0, 2))
      );
      if (_taxType?.length > 0) {
        taxCardListSetter(changes[0][0], "taxType", _taxType[0]);
        formState.taxCard_List[changes[0][0]].taxType = _taxType[0];
        setTaxErrorMsg("");
      } else {
        setTaxErrorMsg("Tax Codes are not available with current selection.");
      }
      // app.$refs.myTable.table.render();
    } else if (changes[0][1] == "supplierJurisdiction") {
      if (!isPo) {
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      } else if (
        formState?.taxCard_List?.filter(
          (i) => i.taxType == formState?.taxCard_List?.[changes[0][0]].taxType
        )?.length <= 1
      )
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      // taxCardListSetter(changes[0][0], "supplierType", "");
      formState.taxCard_List[changes[0][0]].supplierType = "";
      // taxCardListSetter(changes[0][0], "status", "");
      formState.taxCard_List[changes[0][0]].status = "";
      // taxCardListSetter(changes[0][0], "fillingStatus", "");
      formState.taxCard_List[changes[0][0]].fillingStatus = "";
      // taxCardListSetter(changes[0][0], "goodsNature", "");
      formState.taxCard_List[changes[0][0]].goodsNature = "";
      var _d = filterTaxCards(changes[0][0]);
      // taxCardListSetter(changes[0][0], "supplierType", _d[0].supplierType);
      formState.taxCard_List[changes[0][0]].supplierType = _d[0].supplierType;
      // taxCardListSetter(changes[0][0], "status", _d[0].status);
      formState.taxCard_List[changes[0][0]].status = _d[0].status;
      // taxCardListSetter(changes[0][0], "fillingStatus", _d[0].fillingStatus);
      formState.taxCard_List[changes[0][0]].fillingStatus = _d[0].fillingStatus;
      // taxCardListSetter(changes[0][0], "goodsNature", _d[0].goodsNature);
      formState.taxCard_List[changes[0][0]].goodsNature = _d[0].goodsNature;
      // var _taxType = formState?.taxType_list.filter(i => taxCodeList.filter(i => i.TaxCardIds != undefined && i.TaxCardIds != '').filter(i => i.TaxCardIds.split(',').filter(i => _d.map(j => j.Id.toString()).includes(i))).map(i => i.WHTaxType).includes(i.substring(0,2)));
      var _t = taxCodeList.filter(
        (i) => i.TaxCardIds.split(",").indexOf(_d[0].id.toString()) > -1
      );
      var _taxType = formState?.taxType_list?.filter((i) =>
        _t.map((j) => j.WHTaxType).includes(i.substring(0, 2))
      );
      if (_taxType?.length > 0) {
        taxCardListSetter(changes[0][0], "taxType", _taxType[0]);
        formState.taxCard_List[changes[0][0]].taxType = _taxType[0];
        setTaxErrorMsg("");
      } else {
        setTaxErrorMsg("Tax Codes are not available with current selection.");
      }
      // app.$refs.myTable.table.render();
    } else if (changes[0][1] == "supplierType") {
      if (!isPo) {
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      } else if (
        formState?.taxCard_List?.filter(
          (i) => i.taxType == formState?.taxCard_List?.[changes[0][0]].taxType
        )?.length <= 1
      )
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      // taxCardListSetter(changes[0][0], "status", "");
      formState.taxCard_List[changes[0][0]].status = "";
      // taxCardListSetter(changes[0][0], "fillingStatus", "");
      formState.taxCard_List[changes[0][0]].fillingStatus = "";
      // taxCardListSetter(changes[0][0], "goodsNature", "");
      formState.taxCard_List[changes[0][0]].goodsNature = "";
      var _d = filterTaxCards(changes[0][0]);
      // taxCardListSetter(changes[0][0], "status", _d[0].status);
      formState.taxCard_List[changes[0][0]].status = _d[0].status;
      // taxCardListSetter(changes[0][0], "fillingStatus", _d[0].fillingStatus);
      formState.taxCard_List[changes[0][0]].fillingStatus = _d[0].fillingStatus;
      // taxCardListSetter(changes[0][0], "goodsNature", _d[0].goodsNature);
      formState.taxCard_List[changes[0][0]].goodsNature = _d[0].goodsNature;
      // var _taxType = formState?.taxType_list.filter(i => taxCodeList.filter(i => i.TaxCardIds != undefined && i.TaxCardIds != '').filter(i => i.TaxCardIds.split(',').filter(i => _d.map(j => j.id.toString()).includes(i))).map(i => i.WHTaxType).includes(i.substring(0,2)));
      var _t = taxCodeList.filter(
        (i) => i.TaxCardIds.split(",").indexOf(_d[0].id.toString()) > -1
      );
      var _taxType = formState?.taxType_list?.filter((i) =>
        _t.map((j) => j.WHTaxType).includes(i.substring(0, 2))
      );
      if (_taxType?.length > 0) {
        taxCardListSetter(changes[0][0], "taxType", _taxType[0]);
        formState.taxCard_List[changes[0][0]].taxType = _taxType[0];
        setTaxErrorMsg("");
      } else {
        setTaxErrorMsg("Tax Codes are not available with current selection.");
      }
      // app.$refs.myTable.table.render();
    } else if (changes[0][1] == "status") {
      if (!isPo) {
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      } else if (
        formState?.taxCard_List?.filter(
          (i) => i.taxType == formState?.taxCard_List?.[changes[0][0]].taxType
        )?.length <= 1
      )
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      // taxCardListSetter(changes[0][0], "fillingStatus", "");
      formState.taxCard_List[changes[0][0]].fillingStatus = "";
      // taxCardListSetter(changes[0][0], "goodsNature", "");
      formState.taxCard_List[changes[0][0]].goodsNature = "";
      var _d = filterTaxCards(changes[0][0]);
      // taxCardListSetter(changes[0][0], "fillingStatus", _d[0].fillingStatus);
      formState.taxCard_List[changes[0][0]].fillingStatus = _d[0].fillingStatus;
      // taxCardListSetter(changes[0][0], "goodsNature", _d[0].goodsNature);
      formState.taxCard_List[changes[0][0]].goodsNature = _d[0].goodsNature;
      var _t = taxCodeList.filter(
        (i) => i.TaxCardIds.split(",").indexOf(_d[0].id.toString()) > -1
      );
      var _taxType = formState?.taxType_list?.filter((i) =>
        _t.map((j) => j.WHTaxType).includes(i.substring(0, 2))
      );
      if (_taxType?.length > 0) {
        taxCardListSetter(changes[0][0], "taxType", _taxType[0]);
        formState.taxCard_List[changes[0][0]].taxType = _taxType[0];
        setTaxErrorMsg("");
      } else {
        setTaxErrorMsg("Tax Codes are not available with current selection.");
      }
      // app.$refs.myTable.table.render();
    } else if (changes[0][1] == "fillingStatus") {
      if (!isPo) {
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      } else if (
        formState?.taxCard_List?.filter(
          (i) => i.taxType == formState?.taxCard_List?.[changes[0][0]].taxType
        )?.length <= 1
      )
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      // taxCardListSetter(changes[0][0], "goodsNature", "");
      formState.taxCard_List[changes[0][0]].goodsNature = "";
      var _d = filterTaxCards(changes[0][0]);
      // taxCardListSetter(changes[0][0], "goodsNature", _d[0].goodsNature);
      formState.taxCard_List[changes[0][0]].goodsNature = _d[0].goodsNature;
      // var _taxType = formState?.taxType_list.filter(i => taxCodeList.filter(i => i.TaxCardIds != undefined && i.TaxCardIds != '').filter(i => i.TaxCardIds.split(',').filter(i => _d.map(j => j.Id.toString()).includes(i))).map(i => i.WHTaxType).includes(i.substring(0,2)));
      var _t = taxCodeList.filter(
        (i) => i.TaxCardIds.split(",").indexOf(_d[0].id.toString()) > -1
      );
      var _taxType = formState?.taxType_list?.filter((i) =>
        _t.map((j) => j.WHTaxType).includes(i.substring(0, 2))
      );
      if (_taxType?.length > 0) {
        taxCardListSetter(changes[0][0], "taxType", _taxType[0]);
        formState.taxCard_List[changes[0][0]].taxType = _taxType[0];
        setTaxErrorMsg("");
      } else {
        setTaxErrorMsg("Tax Codes are not available with current selection.");
      }
      // app.$refs.myTable.table.render();
    } else if (changes[0][1] == "goodsNature") {
      if (!isPo) {
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
      } else if (
        formState?.taxCard_List?.filter(
          (i) => i.taxType == formState?.taxCard_List?.[changes[0][0]].taxType
        )?.length <= 1
      )
        // taxCardListSetter(changes[0][0], "amount", invoice_Amount);
        formState.taxCard_List[changes[0][0]].amount = invoice_Amount;
      var _d = filterTaxCards(changes[0][0]);
      var _t = taxCodeList.filter(
        (i) => i.TaxCardIds.split(",").indexOf(_d[0].id.toString()) > -1
      );
      // var _taxType = formState?.taxType_list.filter(i => taxCodeList.filter(i => i.TaxCardIds != undefined && i.TaxCardIds != '').filter(i => i.TaxCardIds.split(',').filter(i => _d.map(j => j.id.toString()).includes(i))).map(i => i.WHTaxType).includes(i.substring(0,2)));
      var _taxType = formState?.taxType_list?.filter((i) =>
        _t.map((j) => j.WHTaxType).includes(i.substring(0, 2))
      );
      if (_taxType?.length > 0) {
        var _wcode = whCodes.filter((i) => {
          return i.WHTaxType == _taxType[0].substring(0, 2);
        });
        var _taxCode = _wcode.filter(function (element, index) {
          if (element.TaxCardIds == undefined || element.TaxCardIds == "")
            return false;
          var _c = element.TaxCardIds.split(",");
          var _e = _c.filter((i) => _d.map((j) => j.id.toString()).includes(i));
          return _e?.length > 0;
        });
        var _item = _taxCode.map((i) => {
          return i.TaxCode + " - " + i.Description;
        });

        taxCardListSetter(changes[0][0], "taxType", _taxType[0]);
        formState.taxCard_List[changes[0][0]].taxType = _taxType[0];
        taxCardListSetter(changes[0][0], "taxCode", _item[0]);
        formState.taxCard_List[changes[0][0]].taxCode = _item[0];
        setTaxErrorMsg("");
      } else {
        setTaxErrorMsg("Tax Codes are not available with current selection.");
      }
      // app.$refs.myTable.table.render();
    }
  };
  return (
    <div>
      <Grid container>
        <h3 style={{ color: "red" }}>{taxErrorMsg ? taxErrorMsg : ""}</h3>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ width: "0", zIndex: "0" }}
        >
          <TableContainer className="scrollable">
            <HotTable
              data={formState?.taxCard_List}
              colHeaders={columnHeaders}
              columns={columns}
              manualRowResize={true}
              manualColumnResize={true}
              rowHeaders={true}
              height="200"
              rowHeaderWidth={28}
              contextMenu={true}
              filters={true}
              width="100%"
              readOnly={!edit ||  (status === "SendToIPFromSupervisor" ||  status === "SendToReviewerFromSupervisor") ? true :false}
              // dropdownMenu={true}
              ref={hotRef}
              beforeChange={handleBeforeChange}
              afterChange={handleAfterChange}
              licenseKey="non-commercial-and-evaluation" // for non-commercial use
            />

            {formState?.taxCard_List?.length === 0 ||
            formState?.taxCard_List === undefined ? (
              <EmptyData />
            ) : (
              ""
            )}
          </TableContainer>
          {!show && status !== "SendToIPFromSupervisor" && (
            <Box display="flex" justifyContent={"flex-end"} mt={2}>
              <Button color="secondary" variant="contained" onClick={addInput}>
                Add New Row
              </Button>
            </Box>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default TaxTableV2;
